import * as io from 'io-ts'
import { uuid } from '../../../../packages/io-ts/uuid'

export const selfMeCodec = io.strict({
  id: uuid,
  level: io.union([io.literal('admin'), io.literal('office')]),
  name: io.string,
  surname: io.string,
  username: io.string,
})
